import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=57c3eabb"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c3eabb')) {
      api.createRecord('57c3eabb', component.options)
    } else {
      api.reload('57c3eabb', component.options)
    }
    module.hot.accept("./Setup.vue?vue&type=template&id=57c3eabb", function () {
      api.rerender('57c3eabb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/Setup.vue"
export default component.exports